import { render, staticRenderFns } from "./ServicesReservationAddedServiceForm.vue?vue&type=template&id=4b3e7198&"
import script from "./ServicesReservationAddedServiceForm.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports